import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Alert } from 'shared/ui'
import { GOOGLE_CONNECTION_EXPIRED_ALERT, useLiveDocumentsAccessLost } from 'entities/KnowledgeBase'
import { KnowledgeBaseIndexationStatusAlert } from 'widgets/KnowledgeBase'
import { useKnowledgeBaseViewContext } from 'pages/settings/pages/knowledgeBase/context/knowledgeBaseViewContext'
import { INDEXATION_RETRY } from 'pages/settings/pages/knowledgeBase/lib/constants'
import styles from './styles.module.scss'

export const KnowledgeBaseNotifications = observer(() => {
  const {
    isPageSpinnerShown,
    notificationStore: { notifications, clearNotification },
    knowledgeBaseStore: { knowledgeBase },
    documentsStore: {
      isEmpty,
      onRetryIndexation,
      documentIdsToRetry,
      isDocumentsIndexingRetryLoading,
      hasGoogleSheetLiveDocument,
      hasGoogleDocLiveDocument,
    },
  } = useKnowledgeBaseViewContext()

  const { isGoogleConnectionExpired, reconnectGoogle } = useLiveDocumentsAccessLost({
    hasGoogleSheetLiveDocument,
    hasGoogleDocLiveDocument,
  })

  const isNotificationShown = !!knowledgeBase && !isPageSpinnerShown && !isEmpty

  return (
    <div
      className={classNames(styles.alertContainer, {
        [styles.emptyView]: isEmpty,
      })}
    >
      {isGoogleConnectionExpired && (
        <Alert
          item={{
            type: 'warning',
            desc: GOOGLE_CONNECTION_EXPIRED_ALERT,
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              text: 'Reconnect',
              onClick: reconnectGoogle,
            },
          ]}
        />
      )}
      {isNotificationShown && <KnowledgeBaseIndexationStatusAlert knowledgeBase={knowledgeBase} />}
      {!!documentIdsToRetry.length && (
        <Alert
          item={{
            type: 'error',
            desc: INDEXATION_RETRY,
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              disabled: isDocumentsIndexingRetryLoading,
              text: 'Try again',
              onClick: () => onRetryIndexation(documentIdsToRetry),
            },
          ]}
        />
      )}
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          item={{
            type: notification.type,
            desc: notification.message,
          }}
          onClose={() => clearNotification(notification.id)}
        />
      ))}
    </div>
  )
})
